import type { UpdateSettingsRequest, UpdateSettingsResponse } from '@lunya/contracts'
import { API_PATHS } from '@lunya/contracts'

import { copy } from '~/modules/lunya'
import { createMutation, optimisticUpdate } from '~/shared/api'
import { notifications } from '~/shared/lib/notifications'

import { mapUserFromApi } from './mappers/mapUserFromApi'
import { UserQuery } from './UserQuery'

export type UpdateSettingsInput = {
  forecastTime?: string
  forecastEnabled?: boolean
}

const mapSettingsToApi = (input: UpdateSettingsInput): UpdateSettingsRequest => ({
  forecast_time: input.forecastTime,
  forecast_enabled: input.forecastEnabled,
})

/** PATCH /users/me/settings — время утреннего прогноза и его включённость (спека 07 §2.3). */
export const UpdateSettingsMutation = createMutation<
  UpdateSettingsInput,
  UpdateSettingsResponse,
  ReturnType<typeof mapUserFromApi>
>({
  key: 'user.updateSettings',
  path: API_PATHS.user.settings,
  method: 'PATCH',
  getBody: mapSettingsToApi,
  transform: mapUserFromApi,
  // Тумблер и время обязаны переключаться под пальцем: карточка читает их из кэша UserQuery,
  // поэтому правим его сразу, а сервер догоняет (докладывает правду в onSettled).
  optimistic: [
    optimisticUpdate(UserQuery, (user, input: UpdateSettingsInput) => ({
      ...user,
      forecastTime: input.forecastTime ?? user.forecastTime,
      forecastEnabled: input.forecastEnabled ?? user.forecastEnabled,
    })),
  ],
  sideEffects: {
    invalidateQueries: [UserQuery],
    // Без этого неудачное сохранение выглядит как «тумблер сам вернулся»: правка молча
    // откатывается, и человеку неоткуда узнать, что настройка не доехала.
    onAnyError: () => notifications.error(copy.profile.save_error),
  },
})
